export default [
    {
        path: '/scrumboard',
        component: () => import('@/views/SalesScrumboard'),
        props: true,
    },
];
